<template>
    <templatePublicComponent>
        <div>
            <h3>Guide de déneigement</h3>
            <div class="content">
                <!-- <p>
                    Nous possédons 26 tracteurs avec souffleurs. Nos souffleurs sont munis de couteaux en téflon afin d’éviter la formation de rouille sur le pavé uni.
                </p>
                <div style="text-align:center"><img width="550" src="@/assets/img/image_flotte.jpg"></div> -->

                <h4>Pour une chute de neige de nuit de 5 centimètres et plus :</h4>
                <div>
                    <ul>
                        <li>Nous suivons les chasse-neiges de la ville afin d’enlever la bande de neige laissé par ceux-ci.</li>
                        <li>Ensuite, nous vous demandons de sortir vos véhicules avant 8 heures pour qu’à ce moment nous puissions faire le déneigement complet de votre entrée.</li>
                    </ul>
                </div>
                <h4>Pour une chute de neige de jour de 5 centimètres et plus ou une tempête :</h4>
                <div>
                    <ul>
                        <li>Nous suivons les chasse-neiges de la ville afin d’enlever la bande de neige laissé par ceux-ci.</li>
                        <li>Ce n’est que lorsque la neige cesse de tomber, que le déneigement complet de votre entrée sera fait.</li>
                    </ul>
                </div>
                <div>
                    <p>Important de ne pas laisser d’objet dans l’entrée (exemple : fil électrique, pavé, tapis etc.)</p>
                    <p>Attention au jour de recyclage et poubelles. Veuillez déposer vos bacs sur le côté de votre entrée afin que le tracteur puisse avoir l’accès libre.</p>
                </div>
                <div>
                    <table align="center" border="0" class="faqTab">
                        <tbody>
                            <tr>
                                <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_08.jpg"></td>
                                <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_07.jpg"></td>
                            </tr>
                            <tr>
                                <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_11.jpg"></td>
                                <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_10.jpg"></td>
                            </tr>
                            <tr>
                                <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_04.jpg"></td>
                                <td><img class="faqImg" alt="" src="@/assets/img/guide-deneigement_06.jpg"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </templatePublicComponent>
</template>

<script>
import FrameComponent from '../components/Frame.vue'
import TemplatePublicComponent from '../components/TemplatePublic.vue'
export default {
  components:
  {
    FrameComponent,
    TemplatePublicComponent
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Information.vue